import { ERoles } from '@constants';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { sdk } from '@/services';

const ChatService = sdk.getService('ChatService');

interface UseChatByParticipantsDetailProps {
  propTutorId?: string;
  propStudentId?: string;
}

export const useChatByParticipantsDetail = ({
  propTutorId,
  propStudentId
}: UseChatByParticipantsDetailProps = {}) => {
  const { tutorId, studentId } = useParams();
  const selectedTutorId = propTutorId ?? tutorId;
  const selectedStudentId = propStudentId ?? studentId;

  const queryKey = ['chat', selectedTutorId, selectedStudentId];

  const { isLoading, data } = useQuery({
    queryKey,
    queryFn: () => ChatService.getChatByParticipants(selectedTutorId, selectedStudentId),
    enabled: !!selectedTutorId && !!selectedStudentId
  });

  const student = useMemo(() => {
    return data?.participants.find(user => user.role === ERoles.STUDENT);
  }, [data]);

  const teacher = useMemo(() => {
    return data?.participants.find(user => user.role === ERoles.TEACHER);
  }, [data]);

  return {
    chat: data,
    student,
    teacher,
    isLoading
  };
};
